import React from 'react';
import { Box } from '@chakra-ui/react';
import LoginForm from '../../components/login-form/login-form';

const Login = () => {
    return (
        <Box marginTop={100}>
            <LoginForm />
        </Box>
    )
}

export default Login